import type { TOC } from '@ember/component/template-only';
import Micromodal, {
  type MicromodalSignature
} from 'ember-micromodal/components/micromodal';

export default <template>
  <Micromodal
    class='hidden [&.is-open]:block'
    ...attributes
    as |OverlayElement DialogElement|
  >
    <OverlayElement
      class='fixed inset-0 z-[110] flex justify-center sm:items-center'
    >
      <DialogElement
        class='max-w-620 shadow-modal box-border w-[620px] overflow-y-auto bg-white font-sans sm:max-h-[calc(100vh_-_200px)] sm:rounded'
      >
        {{! will be filled by in-element helper }}
      </DialogElement>
    </OverlayElement>
  </Micromodal>
</template> satisfies TOC<MicromodalSignature>;
